import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import { useTranslate } from 'react-admin'

export const BillingNumberModal = ({openBillingNumber, setOpenBillingNumber}) => {
    const translate = useTranslate()
  return (
    <Dialog open={openBillingNumber} onClose={()=>setOpenBillingNumber(null)}>
        <DialogTitle>
            {translate('ra.entity.supplier-billing')}
        </DialogTitle>
        <DialogContent>
            <div style={{display:'flex', flexDirection:'column'}}>
                {
                    openBillingNumber?.map(num=>(
                        <label style={{fontWeight:'bold'}}>
                            {num}
                        </label>
                    ))
                }
            </div>
        </DialogContent>
        <DialogActions>
            <Button
                color='error'
                variant='outlined'
                onClick={()=>setOpenBillingNumber(null)}
            >
                {translate('ra.action.close')}
            </Button>
        </DialogActions>
    </Dialog>
  )
}